(() => {
  const props = item => item?.properties || {};
  const creationId = item => props(item)._cf_creation_id || props(item)._customization_id || '';
  const isParent = item => !!props(item)._customization_id && !props(item)._cf_parent_creation && !props(item)._tib_customization_id && !props(item)._parent_customization_id;
  function linked(item, parent) {
    if (item.key === parent.key || !isParent(parent)) return false;
    const p = props(item), source = props(parent), id = creationId(parent);
    if (p._cf_parent_creation) return p._cf_parent_creation === id;
    return [p._cf_creation_ref, p._cf_source_customization, p._tib_customization_id, p._parent_customization_id].filter(Boolean).some(ref => ref === id || ref === source._customization_id)
      || !!p._cf_source_line && p._cf_source_line === parent.key
      || !!source._cf_frame_switch && p._cf_tunnel_id === source._cf_frame_switch.replace(/-frame$/, '');
  }
  function label(item) {
    const entry = Object.entries(props(item)).find(([key, value]) => value && /^(citation|pr[ée]nom|titre|ville|frase|nombre|t[ií]tulo|ciudad)\s*:?$/i.test(key));
    return (item.product_title || item.title || '') + (entry ? ' — ' + String(entry[1]).slice(0, 100) : '');
  }
  const children = (cart, parent) => cart.items.filter(item => linked(item, parent));
  const parentOf = (cart, item) => cart.items.find(parent => linked(item, parent));
  const removal = (cart, parent) => Object.fromEntries([parent, ...children(cart, parent)].map(item => [item.key, 0]));
  function optionProperties(parent, properties = {}, labelKey = 'Affiche concernée') {
    const next = {...properties, _cf_parent_creation: creationId(parent), _cf_creation_ref: props(parent)._customization_id};
    delete next['Affiche concernée']; delete next['Lámina correspondiente']; delete next._cf_source_line;
    next[labelKey] = label(parent);
    return next;
  }
  const model = {creationId, isParent, linked, label, children, parentOf, removal, optionProperties};
  if (typeof module !== 'undefined' && module.exports) module.exports = model;
  if (typeof document === 'undefined') return;
  window.cfCreationCart = model;
  const config = JSON.parse(document.getElementById('cf-creation-config').textContent);
  const text = key => config.strings[key];
  const base = window.Shopify?.routes?.root || '/';
  let cart = config.cart, working = false, editing = null, checkoutAllowed = false, dialog;
  let refreshPromise = null;
  const required = item => config.requiredProducts.includes(Number(item.product_id));
  const errorText = error => error?.message || text('error');
  async function request(path, data) {
    const response = await fetch(base + path, {method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: {'Accept':'application/json', ...(data ? {'Content-Type':'application/json'} : {})}, ...(data ? {body:JSON.stringify(data)} : {})});
    const result = await response.json();
    if (!response.ok || result.errors) throw Error(typeof result.description === 'string' ? result.description : text('error'));
    return result;
  }
  function notice(message) {
    let node = document.getElementById('cf-creation-status');
    if (!node) { node = document.createElement('p'); node.id = 'cf-creation-status'; node.className = 'cf-creation-status'; node.setAttribute('role','alert'); (document.querySelector('#main-cart-items') || document.querySelector('main') || document.body).prepend(node); }
    node.textContent = message;
    node.scrollIntoView({block:'nearest'});
  }
  function installHook() {
    const api = window.teeinblue;
    if (!api || api.__cfCreationHook) return;
    const original = api.transformBeforeAddToCart;
    api.transformBeforeAddToCart = async function(input) {
      const result = original ? await original.apply(this, arguments) : input;
      const stamp = item => {
        const p = props(item);
        if (!isParent(item) || config.optionVariants.includes(Number(item.id))) return item;
        const id = p._cf_creation_id || (editing && document.querySelector('.tee-edit-popup #teeAtcButton') ? editing : p._customization_id);
        return {...item, properties:{...p, _cf_creation_id:id}};
      };
      return result?.items ? {...result, items:result.items.map(stamp)} : stamp(result);
    };
    api.__cfCreationHook = true;
  }
  function rowItem(target) {
    const row = target.closest('[data-cf-line-key]');
    return row && cart.items.find(item => item.key === row.dataset.cfLineKey);
  }
  function decorate() {
    document.documentElement.classList.toggle('cf-cart-has-orphan-options', cart.items.some(item => required(item) && !parentOf(cart,item)));
    document.querySelectorAll('[data-cf-line-key]').forEach(row => {
      const item = cart.items.find(line => line.key === row.dataset.cfLineKey);
      if (!item || !isParent(item)) return;
      const linkedItems = children(cart, item);
      let hint = row.querySelector('.cf-creation-remove');
      if (!linkedItems.length) { hint?.remove(); return; }
      if (!hint) {
        hint = document.createElement('button'); hint.type = 'button'; hint.className = 'cf-creation-remove'; hint.dataset.cfRemoveCreation = '';
        row.querySelector('.cart-item__details')?.append(hint);
      }
      hint.textContent = text('remove_group');
      row.querySelectorAll('cart-remove-button a,cart-remove-button button').forEach(control => control.setAttribute('aria-label', text('remove_group')));
    });
  }
  async function reconcile() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = (async () => {
      cart = await request('cart.js');
      let changed = false;
      for (const candidate of [...cart.items]) {
        const item = cart.items.find(line => line.key === candidate.key);
        if (!item || !props(item)._cf_options_v1 || !required(item) && !props(item)._cf_parent_creation && !props(item)._cf_creation_ref && !props(item)._cf_source_line) continue;
        const parent = parentOf(cart, item);
        if (!parent) continue;
        const updated = optionProperties(parent, props(item), text('poster_label'));
        if (Object.keys(updated).every(key => updated[key] === props(item)[key]) && Object.keys(updated).length === Object.keys(props(item)).length) continue;
        cart = await request('cart/change.js', {id:item.key, quantity:item.quantity, properties:updated});
        changed = true;
      }
      decorate();
      return changed;
    })();
    try { return await refreshPromise; } finally { refreshPromise = null; }
  }
  function showDialog(items, orphan = false) {
    if (dialog) dialog.remove();
    dialog = document.createElement('dialog'); dialog.className = 'cf-creation-dialog'; dialog.setAttribute('aria-labelledby','cf-creation-dialog-title');
    const heading = document.createElement('h2'); heading.id = 'cf-creation-dialog-title'; heading.textContent = text(orphan ? 'orphan_title' : 'remove_title');
    const explanation = document.createElement('p'); explanation.textContent = text(orphan ? 'orphan_body' : 'remove_body');
    const list = document.createElement('ul');
    items.forEach(item => { const li = document.createElement('li'); li.textContent = item.quantity + ' × ' + label(item); list.append(li); });
    const status = document.createElement('p'); status.setAttribute('role','alert');
    const actions = document.createElement('div'); actions.className = 'cf-creation-dialog__actions';
    const cancel = document.createElement('button'); cancel.type = 'button'; cancel.textContent = text('cancel'); cancel.onclick = () => dialog.close();
    const confirm = document.createElement('button'); confirm.type = 'button'; confirm.className = 'cf-creation-confirm'; confirm.textContent = text(orphan ? 'remove_orphans' : 'confirm_remove');
    confirm.onclick = async () => {
      if (working) return;
      working = true; confirm.disabled = true; cancel.disabled = true; status.textContent = text('updating');
      try {
        const current = await request('cart.js');
        const keys = items.map(item => item.key);
        if (items.some(item => !current.items.some(line => line.key === item.key && line.quantity === item.quantity))) throw Error(text('cart_changed'));
        if (!orphan) {
          const now = [current.items.find(line => line.key === items[0].key), ...children(current, items[0])];
          if (now.length !== items.length || now.some(item => !keys.includes(item.key))) throw Error(text('cart_changed'));
        }
        const note = document.getElementById('Cart-note');
        cart = await request('cart/update.js', {updates:Object.fromEntries(keys.map(key => [key,0])), ...(note ? {note:note.value} : {})});
        if (cart.items.some(item => keys.includes(item.key))) throw Error(text('error'));
        location.reload();
      } catch (error) { status.textContent = errorText(error); working = false; confirm.disabled = false; cancel.disabled = false; }
    };
    actions.append(cancel,confirm); dialog.append(heading,explanation,list,status,actions); document.body.append(dialog);
    dialog.addEventListener('cancel', event => { if (working) event.preventDefault(); }); dialog.showModal(); cancel.focus();
  }
  async function prepareRemoval(item) {
    if (working) return;
    working = true;
    try {
      if (await reconcile()) { location.reload(); return; }
      const parent = cart.items.find(line => line.key === item.key);
      if (!parent) throw Error(text('cart_changed'));
      showDialog([parent, ...children(cart,parent)]);
    } catch (error) { notice(errorText(error)); } finally { working = false; }
  }
  document.addEventListener('click', event => {
    const edit = event.target.closest('.tee-edit-button');
    if (edit) { const item = rowItem(edit); editing = item ? creationId(item) : null; installHook(); }
    const remove = event.target.closest('cart-remove-button,[data-cf-remove-creation]');
    if (!remove) return;
    const item = rowItem(remove);
    if (!item || !isParent(item)) return;
    event.preventDefault(); event.stopImmediatePropagation(); prepareRemoval(item);
  }, true);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[name="updates[]"]') || Number(input.value) !== 0) return;
    const item = rowItem(input);
    if (!item || !isParent(item)) return;
    event.preventDefault(); event.stopImmediatePropagation(); input.value = item.quantity; prepareRemoval(item);
  }, true);
  async function checkCheckout(resume) {
    if (working) return;
    working = true;
    try {
      if (await reconcile()) { location.reload(); return; }
      const orphaned = cart.items.filter(item => required(item) && !parentOf(cart,item));
      if (orphaned.length) { showDialog(orphaned,true); return; }
      checkoutAllowed = true; resume();
    } catch (error) { notice(errorText(error)); } finally { working = false; }
  }
  document.addEventListener('click', event => {
    if (checkoutAllowed) return;
    const checkout = event.target.closest('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],[data-cfv-checkout]');
    if (!checkout) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkCheckout(() => checkout.click());
  }, true);
  document.addEventListener('submit', event => {
    if (checkoutAllowed || !event.target.matches('form[action$="/cart"]') || event.submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); checkCheckout(() => event.target.requestSubmit(event.submitter));
  }, true);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cf-family-codes] [data-cf-copy-code]');
    if (!button) return;
    event.preventDefault();
    const code = button.dataset.cfCopyCode, host = button.closest('[data-cf-family-codes]'), status = host.querySelector('[role="status"]');
    try {
      await navigator.clipboard.writeText(code);
      button.querySelector('[data-copy-label]').textContent = text('copied');
      button.dataset.copied = 'true';
      status.textContent = text('copy_success').replace('{{ code }}', code);
    } catch (_) { status.textContent = text('copy_failed').replace('{{ code }}', code); }
  });
  document.addEventListener('teeinblue-event-component-injected', installHook);
  installHook();
  decorate();
  document.addEventListener('cart:updated', event => {
    checkoutAllowed = false;
    try { const data = event.detail?.cart; if (data) cart = typeof data === 'string' ? JSON.parse(data) : data; } catch (_) {}
    decorate();
  });
  if (config.cartPage) {
    working = true;
    reconcile().then(changed => { if (changed) location.reload(); }).catch(error => notice(errorText(error))).finally(() => { working = false; });
  }
})();
